import type { SavedHero } from "@greg-chick/shared";

// 히어로 표시명 단일 정의 — 랜딩 무대·월드 입장(Verse)·기타 UI 공용.
// 닉네임 미입력 시 자동 표시명 "꼬마손님-####"(FR-HERO-02/S2-4). 비식별.

function autoName(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return `꼬마손님-${(h % 10000).toString().padStart(4, "0")}`;
}

/**
 * 🔴 **저장할 때마다 이름이 바뀌었다.**
 *
 * 씨앗이 `updatedAt + parts` 였다. 둘 다 **저장하면 바뀐다** — 모자만 바꿔 다시 저장해도
 * 「꼬마손님-8022」가 「꼬마손님-1170」이 된다(실측). 주석은 「결정론적」이라 적어 뒀지만
 * 그건 *같은 저장본 안에서만* 그렇고, **아이 한 사람으로 보면 매번 딴 이름**이다.
 *
 * 이 이름은 반 전시장·선생님 화면·월드 이름표에 그대로 뜬다. 이름이 저절로 바뀌면
 * 친구가 못 알아보고, 선생님은 명단에서 같은 아이를 두 사람으로 본다.
 *
 * 그래서 **여권 코드**를 씨앗으로 쓴다 — 한 번 받으면 안 바뀌고, 익명이라 사람을 못 가린다.
 * 코드를 아직 못 받은(저장 전) 아이만 예전 방식으로 둔다. 그때는 어차피 이름이 확정되기
 * 전이라 바뀌어도 잃을 것이 없다.
 */
export function heroDisplayName(
  hero: Pick<SavedHero, "nickname" | "updatedAt" | "parts" | "code">,
): string {
  if (hero.nickname) return hero.nickname;
  return autoName(hero.code ? `code:${hero.code}` : hero.updatedAt + hero.parts);
}
